import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {stepEnum} from '../Constants/debtPaymentEnum';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import RadioInput from 'app/Components/Shared/RadioInput/RadioInput';
import useEnterKeyPress from '../hooks/useEnterKeyPress';
import {useSelectOptionForUpdatePayment} from '../hooks/useSelectOptionForUpdatePayment';
import {isMobile} from 'react-device-detect';
import {selectServerData, selectEpiData} from '../DebtAndUpdatePaymentBlockSlice';
import Image from 'app/Components/Shared/Image/image';
import {dwhUpdatePaymentMethodReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';

const SelectOptionForUpdatePayment = () => {
  const {selectedUpdatePaymentType, selectedBanData, skipBanSelectForCreditCard, payingEntityLink, actions} =
    useSelectOptionForUpdatePayment();
  const [showError, setShowError] = useState(false);
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);
  const loginData = useSelector((state) => state.authentication.loginData);
  const selectedBansForPaymentUpdate = useSelector((state) => state.debtAndUpdatePayment.selectedBansForPaymentUpdate);

  useEffect(() => {
    dwhUpdatePaymentMethodReport({
      banData: selectedBanData,
      loginData,
      allBans,
      selectedBanNumbers: selectedBansForPaymentUpdate,
      actionType: DwhActionType.PaymentMethodPage,
      messageText: DWHMessageText.PaymentMethodPageDisplayed,
      status: DWHStatus.Ongoing,
      lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
    });
  }, []);

  const getUpdatePaymentMethodReportData = (overrides = {}) => ({
    banData: selectedBanData,
    loginData,
    allBans,
    selectedBanNumbers: selectedBansForPaymentUpdate?.length
      ? selectedBansForPaymentUpdate
      : selectedBanData?.banNumber
      ? [selectedBanData.banNumber]
      : [],
    lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
    ...overrides,
  });

  const radioBtns = [
    {
      id: 'creditcard',
      label: (
        <div className='select_payment_type-label'>
          <span className='select_payment_type-label-icon'>
            <Image src={require('../images/credit_card.svg')} alt='cc' />
          </span>
          <span>כרטיס אשראי </span>
        </div>
      ),
      value: 'creditcard',
    },
    {
      id: 'bank',
      label: (
        <div className='select_payment_type-label'>
          <span className='select_payment_type-label-icon'>
            <Image src={require('../images/bank.svg')} alt='bank' />
          </span>
          <span>הוראת קבע</span>
        </div>
      ),
      value: 'bank',
    },
  ];

  const onRadioBtnChange = (e) => {
    const value = e.currentTarget.value;
    actions.setSelectedUpdatePaymentType(value);
    setShowError(false);
  };

  const setSelectedForUpdate = () => {
    if (!selectedUpdatePaymentType) {
      setShowError(true);
      return;
    }
    const paymentMethodLabel = selectedUpdatePaymentType === 'creditcard' ? 'כרטיס אשראי' : 'הוראת קבע';
    dwhUpdatePaymentMethodReport({
      ...getUpdatePaymentMethodReportData(),
      actionType: DwhActionType.PaymentMethodPage,
      messageText: DWHMessageText.PaymentMethodPageButtonClicked,
      status: DWHStatus.Ongoing,
      param4Value: paymentMethodLabel,
    });
    if (selectedUpdatePaymentType === 'creditcard') {
      if (skipBanSelectForCreditCard && selectedBanData?.banNumber) {
        actions.setSelectedBansForPaymentUpdate([selectedBanData.banNumber]);
        actions.goToStep(stepEnum.CREDITCARD);
      } else {
        actions.goToStep(stepEnum.SELECTUPDATEPAYMENTBAN);
      }
    } else {
      if (selectedBanData?.banNumber) {
        actions.setSelectedBansForPaymentUpdate([selectedBanData.banNumber]);
      }
      actions.goToStep(stepEnum.BANKRANCHSELECTION);
    }
  };
  const handleClick = () => {
    actions.goToStep(stepEnum.SENDSMSENTITYPAYMENT);
  };

  useEnterKeyPress(setSelectedForUpdate);

  return (
    <div className='debtpayment-step select-payment-type update-payment-type'>
      <div className='select-payment-type-top-container'>
        <div className={`${isMobile ? 'm-title' : 'l-title'} extra`} dangerouslySetInnerHTML={{__html: 'בחירת סוג אמצעי תשלום'}} />
      </div>
      <div className='select-payment-type-radio'>
        {radioBtns.map((rb) => {
          return (
            <div className={`radio-btn-item ${selectedUpdatePaymentType == rb.value ? 'checked' : ''} ${rb.value}`} key={rb.id}>
              <RadioInput
                checked={selectedUpdatePaymentType == rb.value}
                id={rb.id}
                name='paymentoption'
                value={rb.value}
                label={rb.label}
                onChange={onRadioBtnChange}
              />
            </div>
          );
        })}
      </div>
      {payingEntityLink && (
        <div type='button' className='btn-link' onClick={() => handleClick()}>
          לעדכון כרטיס אשראי שלא בבעלותך
        </div>
      )}
      <div></div>
      <div className='continue-button'>
        {showError && <span className='error'>כדי להמשיך יש לבחור אמצעי תשלום</span>}
        <BtnSubmit text='המשך ' onclick={setSelectedForUpdate} />
      </div>
    </div>
  );
};

export default SelectOptionForUpdatePayment;
